"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessTypeName = void 0;
var access_type_enum_1 = require("./access-type.enum");
exports.AccessTypeName = (_a = {},
    _a[access_type_enum_1.AccessType.free] = 'Free',
    _a[access_type_enum_1.AccessType.pro] = 'Pro',
    _a[access_type_enum_1.AccessType.team] = 'Team',
    _a[access_type_enum_1.AccessType.academy] = 'Academy',
    _a[access_type_enum_1.AccessType.enterprise] = 'Enterprise',
    _a[access_type_enum_1.AccessType.trial] = 'Trial',
    _a);
